module.exports = __webpack_public_path__ + "img/iteration-shape.74bb6aaa.png";